<template>
  <BaseCard
    title="Document Status Summary"
    class="h-full"
  >
    <template #content>
      <div class="flex flex-col gap-4 min-h-fit">
        <div class="px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div v-if="isLoading">
              <Skeleton
                height="110px"
                width="100%"
              />
            </div>
            <div
              v-else
              class="bg-white border border-gray-200 p-6 rounded-md shadow-sm"
            >
              <BaseNumberRoll
                class="text-2xl font-bold text-primary"
                :end-val="documentStatus.hasAppraisal"
                prefix=""
                suffix=""
                :decimal-places="0"
              />
              <p class="text-sm text-gray-600 mt-1">
                With Appraisal
              </p>
            </div>

            <div v-if="isLoading">
              <Skeleton
                height="110px"
                width="100%"
              />
            </div>
            <div
              v-else
              class="bg-white border border-gray-200 p-6 rounded-md shadow-sm"
            >
              <BaseNumberRoll
                class="text-2xl font-bold text-primary"
                :end-val="documentStatus.hasCIM"
                prefix=""
                suffix=""
                :decimal-places="0"
              />
              <p class="text-sm text-gray-600 mt-1">
                With CIM
              </p>
            </div>

          </div>
        </div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useDashboard } from '~/composables/useDashboardCA'

interface DocumentStatusData {
  hasAppraisal: number
  hasCIM: number
}

interface BusinessAnalyticsResponse {
  pipelineStatus: unknown[]
  documentStatus: DocumentStatusData
  newBusinessesByMonth: unknown[]
  soldBusinessesByMonth: unknown[]
  businessesByAgent: unknown[]
}

const { getBusinessAnalytics } = useDashboard()

const isLoading = ref(true)
const documentStatus = ref<DocumentStatusData>({
  hasAppraisal: 0,
  hasCIM: 0,
})

const getData = async () => {
  isLoading.value = true
  try {
    const response = await getBusinessAnalytics()
    const data = response?.data as BusinessAnalyticsResponse

    if (data) {
      documentStatus.value = data.documentStatus || {
        hasAppraisal: 0,
        hasCIM: 0,
      }
    }
  }
  catch (error) {
    console.error('Error fetching business analytics:', error)
    documentStatus.value = {
      hasAppraisal: 0,
      hasCIM: 0,
    }
  }
  finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  await getData()
})
</script>
